import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FormGroup, Input, Button, Badge, Container } from 'reactstrap';
import { SvgAssets } from '../../assets/icons/iconSvg';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import c from '../../constants/Colors';

import { notificacion, getStatePage } from '../../utilitarios/util';
import { getTransportista } from '../../../src/store/sagas/transportistaApi';
import localStorageCustom from '../../utilitarios/localStorage';
import { AuthContext } from "../../store/provider/AuthProvider";
import Spinner from "../reusable/Loader";

export class TransportistasPerfil extends Component {
  static displayName = TransportistasPerfil.name;
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showModal: false,
      alertTitulo: "",
      alertMensaje: "",
      showAlert: false,
      isActiveModal: false,
      isActiveModal2: false,
      transportes: []
    };
  }
  toggleModal = () => {
    this.setState(prevState => ({
      isActiveModal: !prevState.isActiveModal,
    }));
  }


  notificacion = async (alertTitulo = "", alertMensaje = "") => {
    this.setState({ alertTitulo, alertMensaje });
    this.toggleModalAlert();
  }
  toggleModalAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert,
    }));
  }


  load = (carritoProdctos, setcarritoProdctos) => {

    let storage = localStorageCustom.prototype.getUsuario();
    this.setState({ loading: true });
    getTransportista(storage.dealer.codcliente,
      storage.dealer.correoElectronico,
      storage.linea.vkorg,
      storage.asociado.poblacion)
      .then(result => {
        if (result.mo.type == "success") {
          console.log("result.dto==>", result.dto);
          this.setState({
            transportes: result.dto.transportista.transportes,

          });
          console.log("result.dto.transportista.transporte===>", result.dto.transportista.transporte);
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
        this.setState({ loading: false });
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Transportista", error.message ?? null);
        });
      });


  }


  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0);
      const auth = this.context;
      this.load(auth.carritoProdctos, auth.setcarritoProdctos);
    } else
      window.location.href = "/";
  }
  render() {
    const { loading, transportes } = this.state;

    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1><SvgAssets icon="icon-envio" fill='#fff' />Transportistas</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li><Link to='/perfil' >Mi Perfil</Link></li>
              <li><Link to='/perfil' style={{ pointerEvents: 'none' }}>Transportista</Link></li>
            </ul>
          </Container>
        </div>
        <Container className="pt-5 pb-float">
          <h6 className="title white mobile">
            <Link to={{ pathname: '/carrito/ofertas' }} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></Link>
            <SvgAssets icon="icon-envio" fill="#fff" />Transportistas
          </h6>
          <div style={{ position: 'relative' }}>
            <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
          </div>
          <div className='content_container_transport one'>
            <div className="card container_1080">
              <div className="card_desktop container_datos">
                <h6 className="title-3 text-center mb-4 desktop"><SvgAssets icon="icon-envio" fill="#316ACD" />Transportistas</h6>
              </div>
              <div>
                <ul className='option_transportista'>
                  {transportes.map((item, index) => {
                    return (
                      <li key={"key_" + index}>
                        {item.name1}
                      </li>
                    )
                  })}
                  {/* <li>
                    TRANSPORTE MARVISUR S.A.C
                  </li>
                  <li>
                    TRANSPORTE NUEVO ORIENTE
                  </li>
                  <li>
                    TRANSPORTE CRUCERO DEL SUR
                  </li>
                  <li>
                    TRANSPORTE MARVISUR DE LA CARRETERA CENTRAL S.A.C
                  </li>
                  <li>
                    TRANSPORTE NUEVO ORIENTE
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </Container>
      </div>
    )
  }
}
